<div class="container-fluid pt-3 ">


    <div class="row    " style="    display: flex;

    align-items: center;">

        <div class="col-md-7 pl-0 w-100">
            <p class="m-0 text-uppercase" style="font-size: 20px;
     color: #237dbd;">Rapports</p>

            <small class="text-uppercase" style="font-size:15px">Rapports de flotte </small>

        </div>

        <div class="col-md-5   w-100">
            <div class="row  px-3" style="    display: flex;
    justify-content: flex-end;">

            </div>
        </div>

    </div>
    <div class="row  ">
        <div class="col-md-12 col-xl-3 col-lg-3 pl-0" style="
        border-radius: 7px;">


            <div class="drop " >
                <div class="drop__container  " id="drop-items">

                    <div class="drop__card">
                        <div class="drop__data">
                            <img src="https://img.icons8.com/nolan/64/security-checked.png" alt="Perfil_01"
                                class="drop__img" />
                            <div>
                                <h1 class="drop__name">Score de sécurité</h1>
                                <span class="drop__profession">Scores moyens</span>
                            </div>
                        </div>

                        <div>
                            <a href="#" class="drop__social"><i class="bx bxl-instagram"></i></a>
                            <a href="#" class="drop__social"><i class="bx bxl-twitter"></i></a>
                            <a href="#" class="drop__social"><i class="bx bxl-facebook"></i></a>
                        </div>
                    </div>
                    <div class="drop__card">
                        <div class="drop__data">
                            <img src="https://img.icons8.com/nolan/64/leaf.png" alt="Perfil_01" class="drop__img" />
                            <div>
                                <h1 class="drop__name">Score d'économie</h1>
                                <span class="drop__profession">Scores moyens</span>
                            </div>
                        </div>

                        <div>
                            <a href="#" class="drop__social"><i class="bx bxl-instagram"></i></a>
                            <a href="#" class="drop__social"><i class="bx bxl-twitter"></i></a>
                            <a href="#" class="drop__social"><i class="bx bxl-facebook"></i></a>
                        </div>
                    </div>
                    <div class="drop__card">
                        <div class="drop__data">
                            <img src="https://img.icons8.com/nolan/64/discount.png" alt="Perfil_01" class="drop__img" />
                            <div>
                                <h1 class="drop__name">Moyenne Score de sécurité</h1>
                                <span class="drop__profession">Score sécurité > Moyenne </span>
                            </div>
                        </div>

                        <div>
                            <a href="#" class="drop__social"><i class="bx bxl-instagram"></i></a>
                            <a href="#" class="drop__social"><i class="bx bxl-twitter"></i></a>
                            <a href="#" class="drop__social"><i class="bx bxl-facebook"></i></a>
                        </div>
                    </div>

                    <div class="drop__card">
                        <div class="drop__data">
                            <img src="https://img.icons8.com/nolan/64/discount.png" alt="Perfil_01" class="drop__img" />
                            <div>
                                <h1 class="drop__name">Moyenne Score d'économie</h1>
                                <span class="drop__profession">Score d'économie > Moyenne </span>
                            </div>
                        </div>

                        <div>
                            <a href="#" class="drop__social"><i class="bx bxl-instagram"></i></a>
                            <a href="#" class="drop__social"><i class="bx bxl-twitter"></i></a>
                            <a href="#" class="drop__social"><i class="bx bxl-facebook"></i></a>
                        </div>
                    </div>

                    <div class="drop__card">
                        <div class="drop__data">
                            <img src="https://img.icons8.com/nolan/64/overtime.png" alt="Perfil_01" class="drop__img" />
                            <div>
                                <h1 class="drop__name">Période</h1>
                                <span class="drop__profession"> 02/03/2021 - 02/03/2021 </span>
                            </div>
                        </div>

                        <div>
                            <a href="#" class="drop__social"><i class="bx bxl-instagram"></i></a>
                            <a href="#" class="drop__social"><i class="bx bxl-twitter"></i></a>
                            <a href="#" class="drop__social"><i class="bx bxl-facebook"></i></a>
                        </div>
                    </div>
                    <div class="drop__card">
                        <div class="drop__data">
                            <img src="https://img.icons8.com/nolan/64/real-estate.png" alt="Perfil_01"
                                class="drop__img" />
                            <div>
                                <h1 class="drop__name">Compagnie</h1>
                                <span class="drop__profession">Simbol </span>
                            </div>
                        </div>

                        <div>
                            <a href="#" class="drop__social"><i class="bx bxl-instagram"></i></a>
                            <a href="#" class="drop__social"><i class="bx bxl-twitter"></i></a>
                            <a href="#" class="drop__social"><i class="bx bxl-facebook"></i></a>
                        </div>
                    </div>

                    <div class="drop__card">
                        <div class="drop__data">
                            <img src="https://img.icons8.com/nolan/64/discount.png" alt="Perfil_01" class="drop__img" />
                            <div>
                                <h1 class="drop__name">Moyenne Score de sécurité</h1>
                                <span class="drop__profession">Score sécurité > Moyenne </span>
                            </div>
                        </div>

                        <div>
                            <a href="#" class="drop__social"><i class="bx bxl-instagram"></i></a>
                            <a href="#" class="drop__social"><i class="bx bxl-twitter"></i></a>
                            <a href="#" class="drop__social"><i class="bx bxl-facebook"></i></a>
                        </div>
                    </div>
                    <div class="drop__card">
                        <div class="drop__data">
                            <img src="https://img.icons8.com/nolan/64/boot-open--v2.png" alt="Perfil_01"
                                class="drop__img" />
                            <div>
                                <h1 class="drop__name">Véhicules</h1>
                                <span class="drop__profession">Véhicules inclus 250</span>
                            </div>
                        </div>

                        <div>
                            <a href="#" class="drop__social"><i class="bx bxl-instagram"></i></a>
                            <a href="#" class="drop__social"><i class="bx bxl-twitter"></i></a>
                            <a href="#" class="drop__social"><i class="bx bxl-facebook"></i></a>
                        </div>
                    </div>
                    <div class="drop__card">
                        <div class="drop__data">
                            <img src="https://img.icons8.com/nolan/64/driver.png" alt="Perfil_01" class="drop__img" />
                            <div>
                                <h1 class="drop__name">Conducteurs</h1>
                                <span class="drop__profession">Conducteurs inclus 250</span>
                            </div>
                        </div>

                        <div>
                            <a href="#" class="drop__social"><i class="bx bxl-instagram"></i></a>
                            <a href="#" class="drop__social"><i class="bx bxl-twitter"></i></a>
                            <a href="#" class="drop__social"><i class="bx bxl-facebook"></i></a>
                        </div>
                    </div>
               
                  
                </div>
                <br>
            </div>

         

        </div>

        <div class="col-md-12 col-xl-9 col-lg-9 w-100">
            <iframe class="w-100 " style="    height: 48rem !important;
            border-radius: 10px;
        "
                src="https://apid.stg-app.com/stgdrive/public/uploads/pdf/135/VehicleList_2021030297769.pdf"
                frameborder="0"></iframe>


        </div>

    </div>



</div>